import { useContext } from "react";
import { ServicesContext } from "../contexts/ServicesProvider";

export const useConfiguration = () => {
  const { configurationService } = useContext(ServicesContext);
  return configurationService;
}; 